import { userIsNotAuthenticatedRedir } from 'components/auth/hoc';
import { withTranslation } from 'react-i18next';
import { compose } from 'recompose';
import Invitations from 'pages/Invitations/styled';

const enhance = compose(withTranslation('Login'), userIsNotAuthenticatedRedir);

export default enhance(Invitations);
